import { AttributesOption } from "../../../utils/GeneralTypes";
import { SelectOption } from "../../UI/Inputs/InputSelect";
import { FiltersType } from "./shared";

export const moduleToSelectOptions = (
  options: any,
  labels: [[string, string], string, string],
  dependantNames?: string[] | null,
  dependsOnNames?: string[] | null,
  hasModelsYears?: boolean,
  dependsOnType: "and" | "or" | "default" = "default",
): {
  options: SelectOption[];
  dependantConditions?: { name: string; value: any }[];
  years?: SelectOption[];
} => {
  const refinedOptions: SelectOption[] = [];
  let dependantConditions: { name: string; value: any }[] = [];
  if (dependantNames) {
    dependantConditions = dependantNames.map((el) => ({
      name: el,
      value: {
        no_option: "no_option",
      },
    }));
  }

  options.forEach((item: any) => {
    let alreadyExistingIndex = refinedOptions.findIndex((el) => item.name === el.label);
    if (hasModelsYears ? alreadyExistingIndex === -1 : true) {
      if (dependantNames) {
        dependantConditions.forEach((el) => {
          el.value = Object.assign(el.value, {
            [hasModelsYears ? item.name : item.id]: "no_option",
          });
        });
      }
      refinedOptions.push({
        label: labels[0][1] && item[labels[0][1]] ? item[labels[0][0]] + " " + item[labels[0][1]] : item[labels[0][0]],
        value: item[labels[1]].toString(),
        ...(labels[2] ? { image: item[labels[2]] } : {}),
        ...(dependsOnNames
          ? {
              dependsOn:
                dependsOnType === "default"
                  ? dependsOnNames.map((name) => ({
                      name: name,
                      value: item[`${name}_id`].toString(),
                    }))
                  : {
                      [dependsOnType]: dependsOnNames.map((name) => ({
                        name: name,
                        value: item[`${name}_id`].toString(),
                      })),
                    },
            }
          : {}),
      });
    } else if (
      hasModelsYears &&
      dependsOnNames &&
      !(refinedOptions[alreadyExistingIndex].dependsOn as any)?.or?.find((el: any) => +el.value === +item.brand_id)
    ) {
      refinedOptions[alreadyExistingIndex].dependsOn = {
        or: [
          ...((refinedOptions?.[alreadyExistingIndex]?.dependsOn as any)?.or ?? []),
          {
            name: "brand",
            value: item.brand_id.toString(),
          },
        ],
      };
    }
  });

  refinedOptions.sort((a: any, b: any) => (a.label > b.label ? 1 : -1));

  const years: SelectOption[] = [];
  if (hasModelsYears) {
    const currentYear = new Date().getFullYear() + 1;
    Array(currentYear - 1970)
      .fill(0)
      .forEach((element, index) => {
        years.push({
          label: (1970 + index).toString(),
          value: 1970 + index,
        });
      });
  }
  years.sort((a: any, b: any) => (+a.label < +b.label ? 1 : -1));

  return {
    options: refinedOptions,
    ...(dependantNames ? { dependantConditions: dependantConditions } : {}),
    ...(hasModelsYears ? { years } : {}),
  };
};

export const refactorAttributes = (attributes: any[], trucks: boolean = false) => {
  const refinedAttributes: AttributesOption[] = attributes.map((attr) => ({
    id: attr.id.toString(),
    name: attr.name,
    code: attr.code,
    shape: attr.data_type === "boolean" ? "5" : attr.shape,
    image: attr.icon,
    required: attr.required,
    is_filterable: attr.is_filterable ?? undefined,
    values: attr.values.map((val: any) => ({
      id: val.id.toString(),
      value: val.value,
      name: val.name,
      image: val.icon || attr.icon,
    })),
    ...(trucks ? { parentTruck: attr.parent } : {}),
  }));
  return refinedAttributes;
};

export const refactorSubmittedFilter = (filter: FiltersType, defaultFilters: Partial<FiltersType>) => {
  const submitFilterAttrs: string[] = [];
  const submitFilterValues: string[] = [];
  Object.entries(filter.attributes).forEach((attr: any) => {
    if (attr[1] !== null && attr[1] !== undefined && attr[1] !== "" && attr[1] !== false && attr[1] !== "no_option") {
      submitFilterAttrs.push(attr[0]);
      submitFilterValues.push(attr[1] === true ? 1 : attr[1]);
    }
  });
  const submittedFilter = {
    ...(filter.category_0 !== "no_option" ? { category0: filter.category_0 } : {}),
    // ...(filter.category_1 !== "no_option" ? { category1: filter.category_1 } : {}),
    // ...(filter.category !== "no_option"
    //   ? { category: filter.category }
    //   : {}),
    ...(filter.brand !== "no_option" ? { brand: filter.brand } : {}),
    ...(filter.brand_model !== "no_option" ? { model: filter.brand_model } : {}),
    // ...(filter?.color_id && filter.color_id !== "no_option" ? { color_id: filter.color_id } : {}),
    ...(filter?.city && filter.city !== "no_option" ? { city: filter.city } : {}),
    ...(filter.min_price === defaultFilters.min_price ? {} : { min_price: filter.min_price }),
    ...(filter.max_price === defaultFilters.max_price ? {} : { max_price: filter.max_price }),
    ...(filter.min_year === defaultFilters.min_year ? {} : { min_year: filter.min_year }),
    ...(filter.max_year === defaultFilters.max_year ? {} : { max_year: filter.max_year }),
    ...(filter.min_mileage === defaultFilters.min_mileage ? {} : { min_mileage: filter.min_mileage }),
    ...(filter.max_mileage === defaultFilters.max_mileage ? {} : { max_mileage: filter.max_mileage }),
    // TODO: how is attributes and values are related?
    ...(submitFilterAttrs.length ? { attributes: submitFilterAttrs, values: submitFilterValues } : {}),
  };
  return submittedFilter;
};

function isNumeric(str: string) {
  return !isNaN(+str) && !isNaN(parseFloat(str));
}

/**
 * the function responsible of parsing the search query for find vehicleFilter component.
 *
 * note it doesn't do the actuall state update ONLY PARSE THE SEARCH QUERY
 */
export function refactorFetchedFilter(search: string): Partial<FiltersType> {
  const fetchedFilter: Partial<FiltersType> = {};
  const searchParams = new URLSearchParams(search);

  const brand = searchParams.get("brand") ?? undefined;
  const model = searchParams.get("model") ?? undefined;
  const city = searchParams.get("city") ?? undefined;
  // const color_id = searchParams.get("color_id") ?? undefined;
  // TODO: check how is this formatted to support multiple values
  const attributes = searchParams.get("attributes") ?? undefined;
  const values = searchParams.get("values") ?? undefined;
  const min_price = searchParams.get("min_price") ?? undefined;
  const max_price = searchParams.get("max_price") ?? undefined;
  const min_year = searchParams.get("min_year") ?? undefined;
  const max_year = searchParams.get("max_year") ?? undefined;
  const min_mileage = searchParams.get("min_mileage") ?? undefined;
  const max_mileage = searchParams.get("max_mileage") ?? undefined;
  const category0 = searchParams.get("category0") ?? undefined;
  // const category1 = searchParams.get("category1") ?? undefined;

  if (brand) fetchedFilter.brand = brand;
  if (model) fetchedFilter.brand_model = model;
  if (city) fetchedFilter.city = city;
  // if (color_id) fetchedFilter.color_id = color_id;
  if (min_price && isNumeric(min_price)) fetchedFilter.min_price = +min_price;
  if (max_price && isNumeric(max_price)) fetchedFilter.max_price = +max_price;
  if (min_year && isNumeric(min_year)) fetchedFilter.min_year = +min_year;
  if (max_year && isNumeric(max_year)) fetchedFilter.max_year = +max_year;
  if (min_mileage && isNumeric(min_mileage)) fetchedFilter.min_mileage = +min_mileage;
  if (max_mileage && isNumeric(max_mileage)) fetchedFilter.max_mileage = +max_mileage;
  if (category0) fetchedFilter.category_0 = category0;
  // if (category1) fetchedFilter.category_1 = category1;
  if (attributes && values) {
    const splitedAttributes = attributes.split(",");
    const splitedValues = values.split(",");
    if (splitedAttributes.length === splitedValues.length) {
      const newAttributes: Record<string, string> = {};
      splitedAttributes.forEach((key, index) => {
        if (splitedValues[index]) newAttributes[key] = splitedValues[index];
      });
      fetchedFilter.attributes = newAttributes;
    }
  }
  return fetchedFilter;
}
